import { render, staticRenderFns } from "./vincularWizard.vue?vue&type=template&id=48a36ff7&scoped=true"
import script from "./vincularWizard.vue?vue&type=script&lang=js"
export * from "./vincularWizard.vue?vue&type=script&lang=js"
import style0 from "./vincularWizard.vue?vue&type=style&index=0&id=48a36ff7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a36ff7",
  null
  
)

export default component.exports